import { useTranslation } from 'react-i18next';
import { nationalityPersonSchema, type NationalityPerson } from '@hero/schema';
import { SelectItem } from '../../ui/Select';
import { CustomFormField } from '../../app/CustomFormField';
import { FormFieldTypes } from '@hero/web-types';
import type { Control } from 'react-hook-form';

const NATIONALITIES = nationalityPersonSchema.options;

export interface DriverNationalitiesSelectorProps {
  control: Control<any>;
  name: string;
  disabled?: boolean;
  hideLabel?: boolean;
}

export function DriverNationalitiesSelector({
  control,
  name = '',
  disabled,
  hideLabel,
}: DriverNationalitiesSelectorProps) {
  const { t } = useTranslation(['c-nationalities']);

  return (
    <CustomFormField
      control={control}
      name={name}
      filedType={FormFieldTypes.SELECT}
      placeholder={t('c-nationalities:nationality')}
      label={hideLabel ? undefined : t('c-nationalities:nationality')}
      disabled={disabled}>
      {NATIONALITIES.map((nationality: NationalityPerson) => (
        <SelectItem key={nationality} value={nationality}>
          {t(`c-nationalities:nationalities.${nationality}`)}
        </SelectItem>
      ))}
    </CustomFormField>
  );
}
